import { DefaultSectionCopy, Section } from "@hydrologiq/shared/providers/CopyProvider"

const defaultCopy: DefaultSectionCopy = {
  type: Section.ALERTS,
  name: "Alerts",
  base: "alerts",
  routes: [],
  buttons: [
    { name: "actions.create_alert", label: "Create Alert", description: "Create a new alert" },
    { name: "actions.acknowledge", label: "Acknowledge", description: "Mark alert as acknowledged" },
    { name: "actions.complete", label: "Complete", description: "Mark alert as completed" },
    { name: "actions.add_note", label: "Add Note", description: "Add a note to the alert" },
    { name: "actions.archive", label: "Archive", description: "Archive the alert" },
  ],
  headings: [
    // Headings
    { name: "headings.alerts", value: "Alerts" },
    { name: "headings.alert", value: "Alert" },
    { name: "headings.status", value: "Status" },
    { name: "headings.severity", value: "Severity" },
    { name: "headings.type", value: "Type" },
    { name: "headings.source", value: "Source" },
    { name: "headings.asset", value: "Asset" },
    { name: "headings.message", value: "Message" },
    { name: "headings.fired_at", value: "Fired At" },
    { name: "headings.resolved_at", value: "Resolved At" },
    { name: "headings.created_at", value: "Created At" },
    { name: "headings.assets", value: "Assets" },
    { name: "headings.events", value: "Events" },
    { name: "headings.notes", value: "Notes" },

    // Status labels
    { name: "status.new", value: "New" },
    { name: "status.acknowledged", value: "Acknowledged" },
    { name: "status.attended", value: "Attended" },
    { name: "status.completed", value: "Resolved" },

    // Severity labels
    { name: "severity.critical", value: "Critical" },
    { name: "severity.warning", value: "Warning" },
    { name: "severity.info", value: "Info" },

    // Type labels
    { name: "type.status", value: "Status" },
    { name: "type.pad", value: "PAD" },
    { name: "type.maintenance", value: "Maintenance" },
    { name: "type.anomaly", value: "Anomaly" },
    { name: "type.performance", value: "Performance" },

    // Source labels
    { name: "source.grafana", value: "Grafana" },
    { name: "source.internal", value: "Internal" },
    { name: "source.vendor", value: "Vendor" },

    // Headlines
    { name: "headlines.total_active", value: "Total Active" },
    { name: "headlines.new_alerts", value: "New Alerts" },
    { name: "headlines.critical_alerts", value: "Critical Alerts" },
    { name: "headlines.acknowledged_alerts", value: "Acknowledged Alerts" },
    { name: "headlines.attended_alerts", value: "Attended Alerts" },

    // Messages
    { name: "messages.no_alerts", value: "No alerts found" },
    { name: "messages.alert_created", value: "Alert created successfully" },
    { name: "messages.alert_updated", value: "Alert updated successfully" },
    { name: "messages.note_added", value: "Note added successfully" },
    { name: "messages.alert_archived", value: "Alert archived successfully" },

    // Placeholders
    { name: "placeholders.search_alerts", value: "Search alerts..." },
    { name: "placeholders.alert_message", value: "Enter alert message..." },
    { name: "placeholders.select_asset", value: "Select an asset..." },
    { name: "placeholders.add_note", value: "Add a note..." },
  ],
  statuses: [],
}

export default defaultCopy
